import {AzureLayer} from "@esWebAPI/es/map/layer/azure/AzureLayer";
import { ILayerView, LayerInfo } from "@esWebAPI/es/model/Layer";
import {source, Map, SymbolLayerOptions, layer} from "azure-maps-control";
import {DataDrivenPropertyValueSpecification, ExpressionFilterSpecification} from "@maplibre/maplibre-gl-style-spec";


export class AzureStopSymbolLayer implements AzureLayer {

    private readonly _map: Map;

    private _layerView: ILayerView;

    private _layer: layer.SymbolLayer|undefined;

    private readonly symbolMapping: {[featureId: number]: string} = {};

    private _layerFilter: ExpressionFilterSpecification|undefined;

    private OPACITY = parseFloat(es.util.localStorage.get("STOP_SYMBOL_LAYER_OPACITY") || "0.8");

    constructor(map: Map, layerView: ILayerView, symbolMapping: {[featureId: number]: string}) {
        this._map = map;
        this._layerView = layerView;
        this.symbolMapping = symbolMapping;
    }

    private getOptions(): SymbolLayerOptions {

        let filter = ["==", ['geometry-type'], "Point"] as ExpressionFilterSpecification;
        if (this._layerFilter) {
            filter = ["all", filter, this._layerFilter]
        }

        return {
            iconOptions: {
                anchor: 'center',
                allowOverlap: true,
                ignorePlacement: false,
                optional: false,
                padding: 0,
                opacity: this.OPACITY,
                image: ['get', ['to-string', ['id']], ['literal', this.symbolMapping]]
            },
            sortKey: ['get',"stopNo"],
            zOrder: "source",
            filter
        } as SymbolLayerOptions;
    }

    public async create(datasource: source.Source): Promise<void> {
        this._layer = new layer.SymbolLayer(datasource.getId(), this.getLayerId(), this.getOptions());
        this._map.layers.add(this._layer);
        return Promise.resolve();
    }

    public async update(layerView: ILayerView, _layerInfo: LayerInfo): Promise<void> {
        this._layerView = layerView;
        this._layer?.setOptions(this.getOptions());
        return Promise.resolve();
    }

    public remove(): void {
        const layerId = this.getLayerId();
        if (this._map.layers.getLayerById(layerId)) {
            this._map.layers.remove(layerId);
        }
        this._layer = undefined;
    }

    public hide(): void {
        this._layer?.setOptions({visible: false});
    }

    public show(): void {
        this._layer?.setOptions({visible: true});
    }

    public hideFeature(featureId: number) {
        const opacity = ['case',
            ['==', ['id'], featureId],
            0,
            this.OPACITY
        ] as DataDrivenPropertyValueSpecification<number>;
        this._layer?.setOptions({iconOptions: {opacity: opacity}});
    }

    public showFeatures(): void {
        this._layer?.setOptions({iconOptions: {opacity: this.OPACITY}});
    }

    public getLayerId(): string {
        return "route_stop_symbol_layer_" + this._layerView.id;
    }

    public setLayerFilter(value: ExpressionFilterSpecification | undefined) {
        this._layerFilter = value;
    }
}